/**
 * Ayudantes de autoría: quién hizo algo y cuándo, en el formato que se usa en
 * toda la casa.
 *
 * POR QUÉ ESTÁ AQUÍ
 * ---------------------------------------------------------------------------
 * El modal de documentos vinculados y el editor de documentación enseñan el
 * mismo «Creado por … el … · modificado el …», y la lógica de «¿esto es un
 * nombre o un id?» no se puede duplicar: los documentos anteriores al cambio que
 * guarda el nombre legible llevan el id del IdP, y el CMDB no tiene la tabla de
 * usuarios con la que cruzarlo.
 */

/**
 * Devuelve el nombre a enseñar, o `null` si lo guardado no es un nombre.
 *
 * Un número suelto (`4291`) o un uuid son ids del IdP: enseñarlos no ayuda a
 * nadie, así que se devuelve null y quien llame simplemente omite el «quién».
 */
export function autorLegible(valor) {
  if (!valor) return null;
  const v = String(valor).trim();
  if (!v) return null;
  if (/^\d+$/.test(v)) return null;
  if (/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}/i.test(v)) return null;
  return v;
}

/** Fecha corta: «12 oct 2026». */
export function fechaCorta(iso) {
  if (!iso) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  return d.toLocaleDateString('es-ES', { day: '2-digit', month: 'short', year: 'numeric' });
}

/** Fecha y hora: «12 oct 2026, 18:24». */
export function fechaHora(iso) {
  if (!iso) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  return d.toLocaleString('es-ES', {
    day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit',
  });
}
